import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';
import { Injectable } from '@angular/core';
import {
    ProceduresValidationErrorObject,
} from '@libs/types/src/services/object-type/procedure/procedures.validation-error-object';
import { ProceduresValidationInput } from '@libs/types/src/services/input-type/procedure/procedures.validation-input';
import { procedureValidationFrag } from './types/work.types';
import { SearchInput } from '@libs/types/src/common/input-type/search.input';
import { SearchWorkTypeInput } from '@libs/types/src/common/input-type/search-worktype.input';
import { GridInput } from '@it2go/data-grid';
import { filterFrag } from '../modules/content/service/types/filter.types';
import {
    WorkDataSuggestionEvaluationGridObject,
} from '@libs/types/src/services/object-type/work/work-data-suggestion-evaluation.object';
import { OkObject } from '@it2go/types';
import { IdInput } from '@libs/types/src/common/input-type/id.input';
import {
    WorkDataSuggestionEvaluationCreateInput,
} from '@libs/types/src/services/input-type/work/work-data-suggestion-evaluation.create-input';
import {
    WorkDataSuggestionEvaluationUpdateInput,
} from '@libs/types/src/services/input-type/work/work-data-suggestion-evaluation.update-input';

@Injectable({ providedIn: 'root' })
export class WorkGqlService extends GqlServiceV2 {

    public async validateProcedures(input: ProceduresValidationInput, frag = procedureValidationFrag): Promise<ProceduresValidationErrorObject[]> {
        return this.query(
            `
                query($input: ProceduresValidationInput!) {
                    performedProcedure {
                        validate(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public async searchWorkTags(input: SearchWorkTypeInput): Promise<string[]> {
        return this.query(
            `
                query($input: SearchWorkTypeInput!) {
                    work {
                        searchTags(input: $input)
                    }
                }
            `,
            { input },
        );
    }

    public async searchWorkOfferTags(input: SearchInput): Promise<string[]> {
        return this.query(
            `
                query($input: SearchInput!) {
                    workOffer {
                        searchTags(input: $input)
                    }
                }
            `,
            { input },
        );
    }

    public getWorkSuggestionEvaluations(input: GridInput, fragment: string) {
        return this.query<WorkDataSuggestionEvaluationGridObject>(
            `
                query($input: GridInput!) {
                    workDataSuggestionEvaluation {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${fragment}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public async createWorkSuggestionEvaluation(input: WorkDataSuggestionEvaluationCreateInput, fragment: string = 'ok'): Promise<OkObject> {
        return this.mutate<OkObject>(
            `
                mutation($input: WorkDataSuggestionEvaluationCreateInput!) {
                    workDataSuggestionEvaluation {
                        create(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public async updateWorkSuggestionEvaluation(input: WorkDataSuggestionEvaluationUpdateInput, fragment: string = 'ok'): Promise<OkObject> {
        return this.mutate<OkObject>(
            `
                mutation($input: WorkDataSuggestionEvaluationUpdateInput!) {
                    workDataSuggestionEvaluation {
                        update(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public async deleteWorkSuggestionEvaluation(input: IdInput, fragment: string = 'ok'): Promise<OkObject> {
        return this.mutate<OkObject>(
            `
                mutation($input: IdInput!) {
                    workDataSuggestionEvaluation {
                        delete(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

}
